/**
 * Utility functions for file downloads
 */

/**
 * Downloads data as a file
 */
export function downloadFile(
  content: string,
  filename: string,
  mimeType: string = "application/json",
): void {
  // Create a Blob containing the data
  const blob = new Blob([content], { type: mimeType });

  // Create a temporary download link
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;

  // Append to body, trigger download, and clean up
  document.body.appendChild(link);
  link.click();

  // Clean up
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}

/**
 * Downloads JSON data as a file
 */
export function downloadJSON(
  data: unknown,
  filename: string,
  pretty: boolean = true,
): void {
  const content = pretty ? JSON.stringify(data, null, 2) : JSON.stringify(data);
  const safeFilename = String(filename || "export");
  const filenameWithExt = safeFilename.endsWith(".json")
    ? safeFilename
    : `${safeFilename}.json`;
  downloadFile(content, filenameWithExt, "application/json");
}

/**
 * Sanitizes a string for use in filenames
 * Only removes characters that are invalid in Windows/Mac/Linux filenames
 */
export function sanitizeFilename(name: string): string {
  // Remove only truly problematic characters: < > : " / \ | ? *
  // Keep: letters (any case), numbers, spaces, dashes, underscores, parentheses, etc.
  return name.replace(/[<>:"/\\|?*]/g, "_");
}
